import React, { useState } from "react";
import PropTypes from "prop-types";
import ti18n from 'i18n!nls/Sequenceri18n';
import Tooltip from "./common/Tooltip";
import TrebbleFilterCascader from "./common/FilterCascader";
import TrebbleCheckbox from "./common/Checkbox";
import SequencerSearchWidget from "../models/audioEditor/SequencerSearchWidget";

const SEARCH_TYPE = SequencerSearchWidget.SEARCH_TYPE;

const EditorSearchResults = ({ 
    searchWidgetData,
    hasResults,
    applyAllButtonLabel,
    onApplyAllButtonClick,
    onSafeCutToggle,
    onFilterChange,
    searchWidgetModel
}) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    if (!hasResults && !searchWidgetData.shouldSafeBeAvailable) {
        return null;
    }

    return (
        <>
            {/* Safe Cut Toggle */}
            {searchWidgetData.shouldSafeBeAvailable && (
                <div className="flex flex-row items-center mb-2" style={{alignItems: 'center'}}>
                    <TrebbleCheckbox
                        aria-label={window.getI18n(ti18n, "HIDE_RESULTS_ABRUPT")}
                        style={{display:"flex",margin:"0px"}}
                        checked={searchWidgetData.onShowSafeCut}
                        onChange={e => onSafeCutToggle(e.target.checked)}
                        useEditorTheme={true}
                        id="safe-cut-checkbox"
                    />
                    <span htmlFor="safe-cut-checkbox" className="text-left ml-2">
                        {window.getI18n(ti18n, "HIDE_RESULTS_ABRUPT")}
                    </span>
                    
                    <Tooltip title={window.getI18n(ti18n, "SAFE_CUT_INFO")} placement="top">
                        <button type="button">
                        <span
                            className="icon pe-7s-info text-lg"
                            tabIndex={0}
                            aria-label={window.getI18n(ti18n, "SAFE_CUT_INFO")}
                            role="img"
                            style={{ cursor: 'pointer', outline: 'none'}}
                        />
                        </button>
                    </Tooltip>
                </div>
            )}

            {/* Results Navigation and Controls */}
            <div className="flex flex-row justify-center items-center">
                <div className="flex flex-col">
                    <div>
                        {hasResults 
                            ? (searchWidgetData.searchResultIndexInFocus === -1 
                                ? `- ${window.getI18n(ti18n, "OF")} ${searchWidgetData.numberOfSearchNodesFound}`
                                : `${searchWidgetData.searchResultIndexInFocus + 1} ${window.getI18n(ti18n, "OF")} ${searchWidgetData.numberOfSearchNodesFound}`)
                            : `0 ${window.getI18n(ti18n, "OF")} 0`
                        }
                    </div>
                </div>
                
                <div className="flex flex-col">
                    <Tooltip title={window.getI18n(ti18n,"PREVIOUS_RESULT")} placement="bottom" align="center">
                        <button 
                            onClick={() => searchWidgetModel.moveToPreviousFoundNodeWithPreview()}  
                            disabled={!searchWidgetData.canMoveToPreviousResult} 
                            className={!searchWidgetData.canMoveToPreviousResult ? "disabled" : ""}
                        >
                            <span className="icon ion-ios7-arrow-thin-up text-3xl"></span>
                        </button>
                    </Tooltip>
                </div>
                
                <div className="flex flex-col">
                    <Tooltip title={window.getI18n(ti18n,"NEXT_RESULT")} placement="bottom" align="center">
                        <button 
                            onClick={() => searchWidgetModel.moveToNextFoundNodeWithPreview()} 
                            disabled={!searchWidgetData.canMoveToNextResult} 
                            className={!searchWidgetData.canMoveToNextResult ? "disabled" : ""}
                        >
                            <span className="icon ion-ios7-arrow-thin-down text-3xl"></span>
                        </button>
                    </Tooltip>
                </div>
                
                {/* Filter Controls */}
                {searchWidgetData.allfilterProperties && (
                    <div className="flex flex-col">
                        <TrebbleFilterCascader 
                            useEditorTheme={true}
                            onChange={onFilterChange}
                            value={searchWidgetData.filterOptions}
                            open={isFilterOpen}
                            options={searchWidgetData.allfilterProperties}
                            onOpenChange={setIsFilterOpen}
                        >
                            <Tooltip title={window.getI18n(ti18n,"FILTER_RESULTS")} placement="bottom" align="center">
                                <button 
                                    onClick={(e) => e.preventDefault()}
                                    className="flex items-center justify-center"
                                >
                                    <span className="icon pe-7s-filter text-2xl"></span>
                                </button>
                            </Tooltip>
                        </TrebbleFilterCascader>
                    </div>
                )}
                
                {/* Apply All Button */}
                <div className="flex flex-col">
                    <button 
                        disabled={!hasResults} 
                        className={`button_with_label ${!hasResults ? "disabled" : ""}`} 
                        onClick={onApplyAllButtonClick}
                    >
                        <label>{applyAllButtonLabel}</label>
                    </button>
                </div>
            </div>
        </>
    );
};

EditorSearchResults.propTypes = {
    searchWidgetData: PropTypes.object.isRequired,
    hasResults: PropTypes.bool,
    applyAllButtonLabel: PropTypes.string,
    onApplyAllButtonClick: PropTypes.func,
    onSafeCutToggle: PropTypes.func,
    onFilterChange: PropTypes.func,
    searchWidgetModel: PropTypes.object
};

export default EditorSearchResults; 